import { SET_RESUME_QUESTION_OBJECT } from "../action/resumeCarouselActions";

const initialState = {
  resumeQuestionObject: {},
};

export default function ResumeQuestionJsonReducer(state = initialState, action) {
  switch (action.type) {
    case SET_RESUME_QUESTION_OBJECT:
      return {
        ...state,
        resumeQuestionObject: action.payload,
      };
    // Add more cases as needed
    default:
      return state;
  }
}
